var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('b-spinner',{staticClass:"d-block mx-auto text-primary my-2"}):_c('layout-vertical',[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }